import { object, string } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';

import {
    getCommonFieldsValidationSchema,
    getExtraFieldsValidationSchema,
} from './validateCommonFields';

export default (values) => {
    const { REQUIRED_TEXT } = getValidationTexts();

    const shape = {
        drawing_mode: string().required(REQUIRED_TEXT).nullable(),
        ...getCommonFieldsValidationSchema(values),
        ...getExtraFieldsValidationSchema(values),
    };

    return object().shape(shape);
};
